import { graphql, useStaticQuery, navigate } from 'gatsby';
import React, {
  useState,
  useMemo,
  useRef,
  useEffect,
  useCallback,
} from 'react';
import styled, { keyframes } from 'styled-components';
import Branded from '../components/Branded';
import SEO from '../components/SEO';
import Footer from '../sections/Footer';

const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

/* ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã‚ÂÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã‚ÂÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã‚ÂÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ Hero "Our Work" ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã‚ÂÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã‚ÂÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã‚ÂÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ */
const HeroSection = styled.section`
  position: relative;
  height: 80vh;
  min-height: 520px;
  overflow: hidden;
  background: #0b1f3a;

  .hero-media,
  .hero-video {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .hero-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(
      180deg,
      rgba(11, 31, 58, 0.92) 0%,
      rgba(11, 31, 58, 0.82) 100%
    );
    z-index: 1;
  }

  .hero-content {
    position: absolute;
    inset: 0;
    z-index: 2;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 0 24px;
  }

  .hero-tag {
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0.22em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.85);
    margin-bottom: 24px;
    animation: ${fadeUp} 0.8s ease 0.1s both;

    &::before,
    &::after {
      content: '';
      display: inline-block;
      width: 28px;
      height: 1px;
      background: rgba(255, 255, 255, 0.6);
      vertical-align: middle;
      margin: 0 14px;
    }
  }

  .hero-title {
    display: inline-block;
    font-size: clamp(1.6rem, 3.4vw, 2.6rem);
    font-weight: 700;
    color: #fff;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    background: #f08020;
    padding: 18px 56px;
    border-radius: 4px;
    margin: 0 0 32px;
    animation: ${fadeUp} 0.8s ease 0.25s both;

    @media (max-width: 768px) {
      padding: 14px 36px;
    }
  }

  .hero-desc {
    /* Brand blue is too dark against the hero overlay */
    .brand-space {
      color: #8fc4f7;
    }

    font-size: 15px;
    font-weight: 300;
    color: rgba(255, 255, 255, 0.85);
    line-height: 1.8;
    max-width: 720px;
    margin: 0;
    animation: ${fadeUp} 0.8s ease 0.4s both;

    @media (max-width: 768px) {
      font-size: 14px;
    }
  }
`;

/* ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã‚ÂÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã‚ÂÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã‚ÂÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ Tabs + Grid ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã‚ÂÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã‚ÂÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã‚ÂÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ */
const GridSection = styled.section`
  background: #fff;
  padding: 72px 24px 96px;
  border-bottom: 1px solid #d8e1ec;

  @media (max-width: 768px) {
    padding: 48px 20px 64px;
  }

  .grid-inner {
    max-width: 1280px;
    margin: 0 auto;
  }
`;

const Tabs = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 14px;

  @media (max-width: 768px) {
    gap: 10px;
  }
`;

const Tab = styled.button`
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.04em;
  padding: 12px 28px;
  background: ${({ active }) => (active ? '#1378E5' : '#fff')};
  color: ${({ active }) => (active ? '#fff' : '#5B6B7C')};
  border: 1.5px solid ${({ active }) => (active ? '#1378E5' : '#D8E1EC')};
  border-radius: 2px;
  cursor: pointer;
  transition: all 0.25s ease;
  white-space: nowrap;

  &:hover {
    background: ${({ active }) => (active ? '#1378E5' : '#fff')};
    color: ${({ active }) => (active ? '#fff' : '#1378E5')};
    border-color: #1378e5;
  }

  @media (max-width: 768px) {
    padding: 10px 18px;
    font-size: 12px;
  }
`;

const ScrollWrap = styled.div`
  overflow-x: scroll;
  overflow-y: hidden;
  position: relative;
  cursor: grab;
  user-select: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  &:active {
    cursor: grabbing;
  }
`;

const ScrollTrack = styled.div`
  display: flex;
  gap: 20px;
  width: max-content;

  @media (max-width: 768px) {
    gap: 14px;
  }
`;

const ProjectCard = styled.div`
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  cursor: pointer;
  width: 420px;
  height: 320px;
  flex-shrink: 0;
  background: #f2f6fc;

  @media (max-width: 768px) {
    width: 320px;
    height: 240px;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    transition: transform 0.7s cubic-bezier(0.16, 1, 0.3, 1);
  }

  .card-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(
      to top,
      rgba(11, 31, 58, 0.85) 0%,
      rgba(11, 31, 58, 0.1) 55%,
      transparent 100%
    );
    z-index: 1;
  }

  .card-info {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 22px 24px;
    z-index: 2;
  }

  .card-cat {
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    color: #f08020;
    margin-bottom: 6px;
  }

  .card-title {
    font-size: 15px;
    font-weight: 600;
    color: #fff;
    line-height: 1.35;
  }

  .card-desc {
    margin-top: 6px;
    font-size: 12.5px;
    font-weight: 300;
    color: rgba(255, 255, 255, 0.82);
    line-height: 1.55;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  &:hover img {
    transform: scale(1.06);
  }

  .card-placeholder {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #5b6b7c;
    font-size: 13px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
  }
`;

const EmptyState = styled.div`
  text-align: center;
  padding: 48px 24px;
  color: #5b6b7c;
  font-size: 14px;
`;

const portfolioQuery = graphql`
  {
    sanityProjectsPage {
      heroTag
      heroTitle
      heroSubtitle
      heroImage {
        asset {
          _id
          url
        }
      }
      seoTitle
      seoDescription
    }
    allSanityProject {
      nodes {
        _id
        title
        description
        slug {
          current
        }
        coverImage {
          asset {
            _id
            url
          }
        }
        category {
          _id
          name
          slug {
            current
          }
        }
      }
    }
    allSanityProjectCategory(sort: { fields: position, order: ASC }) {
      nodes {
        _id
        name
        slug {
          current
        }
      }
    }
  }
`;

export default function PortfolioPage() {
  const data = useStaticQuery(portfolioQuery);
  const page = data?.sanityProjectsPage;
  const projects = data?.allSanityProject?.nodes || [];
  const categories = data?.allSanityProjectCategory?.nodes || [];

  const [activeCategory, setActiveCategory] = useState(null);
  const [needsLoop, setNeedsLoop] = useState(false);
  const scrollRef = useRef(null);
  const isDragging = useRef(false);
  const hasDragged = useRef(false);
  const startX = useRef(0);
  const scrollLeft = useRef(0);
  const autoSpeed = useRef(0.8);
  const rafId = useRef(null);

  const filtered = useMemo(() => {
    if (!activeCategory) return projects;
    return projects.filter(p => p.category?._id === activeCategory);
  }, [activeCategory, projects]);

  const items = needsLoop ? [...filtered, ...filtered, ...filtered] : filtered;

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return undefined;

    const check = () => {
      const cardWidth = window.innerWidth <= 768 ? 334 : 440; // card + gap
      setNeedsLoop(filtered.length * cardWidth > el.clientWidth);
    };

    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, [filtered.length]);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el || !needsLoop || filtered.length < 2) return undefined;

    const tick = () => {
      if (!isDragging.current) {
        el.scrollLeft += autoSpeed.current;
        const oneSet = el.scrollWidth / 3;
        if (el.scrollLeft >= oneSet * 2) el.scrollLeft -= oneSet;
        if (el.scrollLeft <= 0) el.scrollLeft += oneSet;
      }
      rafId.current = requestAnimationFrame(tick);
    };

    el.scrollLeft = el.scrollWidth / 3;
    rafId.current = requestAnimationFrame(tick);

    return () => {
      if (rafId.current) cancelAnimationFrame(rafId.current);
    };
  }, [filtered.length, activeCategory, needsLoop]);

  const onMouseDown = useCallback(e => {
    isDragging.current = true;
    hasDragged.current = false;
    startX.current = e.pageX;
    scrollLeft.current = scrollRef.current.scrollLeft;
  }, []);

  const onMouseMove = useCallback(e => {
    if (!isDragging.current) return;
    e.preventDefault();
    const dx = e.pageX - startX.current;
    if (Math.abs(dx) > 5) hasDragged.current = true;
    scrollRef.current.scrollLeft = scrollLeft.current - dx;
  }, []);

  const onTouchStart = useCallback(e => {
    isDragging.current = true;
    hasDragged.current = false;
    startX.current = e.touches[0].pageX;
    scrollLeft.current = scrollRef.current.scrollLeft;
  }, []);

  const onTouchMove = useCallback(e => {
    if (!isDragging.current) return;
    const dx = e.touches[0].pageX - startX.current;
    if (Math.abs(dx) > 5) hasDragged.current = true;
    scrollRef.current.scrollLeft = scrollLeft.current - dx;
  }, []);

  useEffect(() => {
    const stop = () => {
      isDragging.current = false;
    };
    document.addEventListener('mouseup', stop);
    document.addEventListener('touchend', stop);
    return () => {
      document.removeEventListener('mouseup', stop);
      document.removeEventListener('touchend', stop);
    };
  }, []);

  return (
    <div>
      <SEO
        title={page?.seoTitle || 'Projects - Decorzo Space'}
        description={page?.seoDescription}
      />

      {/* Hero ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â Our Work */}
      <HeroSection>
        {page?.heroImage?.asset?.url && (
          <img
            className="hero-media"
            src={page.heroImage.asset.url + '?w=1920&auto=format'}
            alt={page?.heroTitle || ''}
          />
        )}
        <div className="hero-overlay" />
        <div className="hero-content">
          {page?.heroTag && <div className="hero-tag">{page.heroTag}</div>}
          {page?.heroTitle && <h1 className="hero-title">{page.heroTitle}</h1>}
          {page?.heroSubtitle && (
            <Branded as="p" className="hero-desc" text={page.heroSubtitle} />
          )}
        </div>
      </HeroSection>

      {/* Tabs + Grid */}
      <GridSection>
        <div className="grid-inner">
          <Tabs>
            <Tab
              active={!activeCategory}
              onClick={() => setActiveCategory(null)}
            >
              All
            </Tab>
            {categories.map(cat => (
              <Tab
                key={cat._id}
                active={activeCategory === cat._id}
                onClick={() => setActiveCategory(cat._id)}
              >
                {cat.name}
              </Tab>
            ))}
          </Tabs>

          <div style={{ height: 32 }} />

          {filtered.length === 0 ? (
            <EmptyState>No projects in this category yet.</EmptyState>
          ) : (
            <ScrollWrap
              ref={scrollRef}
              onMouseDown={onMouseDown}
              onMouseMove={onMouseMove}
              onTouchStart={onTouchStart}
              onTouchMove={onTouchMove}
            >
              <ScrollTrack key={activeCategory || 'all'}>
                {items.map((project, idx) => {
                  const slug = project.slug?.current;
                  const img = project.coverImage?.asset?.url;
                  return (
                    <ProjectCard
                      key={`${project._id}-${idx}`}
                      onClick={() => {
                        if (!hasDragged.current && slug)
                          navigate(`/portfolio/${slug}`);
                      }}
                    >
                      {img ? (
                        <img
                          src={img + '?w=800&auto=format'}
                          alt={project.title || ''}
                          loading="lazy"
                          draggable="false"
                        />
                      ) : (
                        <div className="card-placeholder">Image</div>
                      )}
                      <div className="card-overlay" />
                      <div className="card-info">
                        {project.category?.name && (
                          <div className="card-cat">
                            {project.category.name}
                          </div>
                        )}
                        {project.title && (
                          <div className="card-title">{project.title}</div>
                        )}
                        {project.description && (
                          <div className="card-desc">{project.description}</div>
                        )}
                      </div>
                    </ProjectCard>
                  );
                })}
              </ScrollTrack>
            </ScrollWrap>
          )}
        </div>
      </GridSection>

      <Footer />
    </div>
  );
}
